import { QuizType } from "containers/Dashboard/Games/store";
import { stringify } from "qs";

export const addURLParam = (obj: any): string => stringify(obj, { addQueryPrefix: true, skipNulls: true });

export const getQuizType = (url: string): QuizType => (url.split("/").includes("video-quiz") ? "VIDEO" : "CLASSIC");
